import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import api from "@/lib/api";
import { Clock } from "lucide-react";

const CATEGORIES = ["Alle", "Renovatie", "Elektriciteit", "IT", "Algemeen", "Tips"];

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState("Alle");

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data || [])).catch(() => setPosts([]));
  }, []);

  const filtered = filter === "Alle" ? posts : posts.filter((p) => p.category === filter);

  return (
    <PublicLayout>
      <section className="oc-section">
        <div className="oc-container">
          <span className="text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">Blog</span>
          <h1 className="font-display font-bold text-[40px] sm:text-[52px] leading-tight tracking-tight text-oc-primary mt-3">
            Tips, prijzen en marktinzicht
          </h1>
          <p className="mt-4 text-oc-textSecondary text-[17px] leading-relaxed max-w-2xl">
            Artikels die je helpen offertes beter te begrijpen, prijzen te vergelijken en betere beslissingen te nemen.
          </p>

          <div className="mt-10 flex flex-wrap gap-2">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`blog-filter-${c.toLowerCase()}`}
                className={`px-4 py-2 rounded-full text-[13px] font-semibold border transition-colors ${
                  filter === c
                    ? "bg-oc-primary text-white border-oc-primary"
                    : "bg-white text-oc-textSecondary border-oc-border hover:bg-oc-subtle"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="group bg-white rounded-oc border border-oc-border overflow-hidden transition-all hover:-translate-y-1 hover:shadow-oc-card-hover"
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="aspect-[16/9] bg-oc-subtle overflow-hidden">
                  {p.thumbnail ? (
                    <img src={p.thumbnail} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  ) : null}
                </div>
                <div className="p-7">
                  <span className="text-[12px] uppercase tracking-[0.08em] font-semibold text-oc-secondary">{p.category}</span>
                  <h3 className="font-display font-semibold text-oc-primary text-[20px] mt-2 leading-snug">{p.title}</h3>
                  <p className="mt-2 text-oc-textSecondary text-[14px] line-clamp-3">{p.excerpt}</p>
                  <p className="mt-5 flex items-center gap-2 text-oc-textSecondary text-[12px]">
                    <Clock className="w-3.5 h-3.5" /> {p.read_time} min leestijd
                  </p>
                </div>
              </Link>
            ))}
            {filtered.length === 0 && (
              <p className="col-span-full text-oc-textSecondary text-center py-10">Geen artikels in deze categorie.</p>
            )}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
